/**
 * Pagination constants used throughout the application
 */

export const ITEMS_PER_PAGE = 25;

// Legacy exports for backward compatibility
export const EXPENSES_PER_PAGE = ITEMS_PER_PAGE;
export const GROUPS_PER_PAGE = 25;
